import { updateDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";
import HelperForMetaData from "../../helpers/HelperForMetaData";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const UpdateSingleLead = async (e, LeadId) => {
  /**
   * input: null
   * output: lead document / collection
   * description: update lead / lead document
   */
  try {
    const leadsDoc = await doc(db, "leads", LeadId);

    /** Check if new lead duplicates, return */
    // const q = query(leadsCollection, where("cnic", "==", e.cnic));
    // const duplicateDocs = await getDocs(q);
    // const duplicateDocsExist = duplicateDocs.docs.length > 0 ? true : false;
    // if (duplicateDocsExist && e.cnic !== "") return null;

    const data = HelperForMetaData({
      ...e,
      bid: getLocalStorageItem("bid"),
    });
    delete data.createdAt;
    const result = await updateDoc(leadsDoc, data);
    return result;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default UpdateSingleLead;
